import { useQuery, useMutation, useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import { apiClient } from '../services/apiClient';
import { CustomerReadDTO, CustomerCreateDTO } from '../generated/api-client';
import { getAxiosErrorDetail } from '../utils/axiosErrorDetail';

export const useCustomers = () => {
  return useQuery<CustomerReadDTO[]>('customers', () => apiClient.list_items_customers__get());
};

export const useCustomer = (id: string) => {
  return useQuery<CustomerReadDTO>(
    ['customer', id],
    () => apiClient.get_item_customers__item_id__get(id),
    {
      enabled: !!id,
    }
  );
};

export const useCustomersByName = (name: string) => {
  return useQuery<CustomerReadDTO[]>(
    ['customers', 'byName', name],
    () => apiClient.search_by_name_customers_search_by_name__name__get(name),
    {
      enabled: !!name,
    }
  );
};

export const useCreateCustomer = () => {
  const queryClient = useQueryClient();

  return useMutation<CustomerReadDTO, Error, CustomerCreateDTO>(
    (data) => apiClient.create_item_customers__post(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('customers');
      },
    }
  );
};

export const useUpdateCustomer = () => {
  const queryClient = useQueryClient();

  return useMutation<CustomerReadDTO, Error, { id: string; data: CustomerCreateDTO }>(
    ({ id, data }) => apiClient.update_item_customers__item_id__put(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('customers');
      },
    }
  );
};

export const useDeleteCustomer = () => {
  const queryClient = useQueryClient();

  return useMutation<any, Error, string>(
    (id) => apiClient.delete_item_customers__item_id__delete(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('customers');
      },
      onError: error => {
        toast.error(getAxiosErrorDetail(error, "Errore nell'eliminazione del cliente"));
      },
    }
  );
};

